<form id="change-users-role-form" [formGroup]="changeRoleForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate($event)">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <span formGroupName="role">
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label>Loyalty</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown formControlName="loyalty_role" [options]="grantRolesLoyalty" [style]="{ width: '100%' }">
          </p-dropdown>
        </div>
      </div>
    </span>
    <span formGroupName="role">
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label>Promotion</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown formControlName="promo_role" [options]="grantRolesPromotion" [style]="{ width: '100%' }">
          </p-dropdown>
        </div>
      </div>
    </span>
    <span formGroupName="role">
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label>Common</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown formControlName="common_role" [options]="grantRolesCommon" [style]="{ width: '100%' } "></p-dropdown>
        </div>
      </div>
    </span>
    <span formGroupName="role">
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label>Customer</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown formControlName="customer_role" [options]="grantRolesCustomer" [style]="{ width: '100%' }"></p-dropdown>
        </div>
      </div>
    </span>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"
      style="display: flex; justify-content: center; border: 0">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="Modifica"></button>
    </div>
  </p-footer>
</form>


// WEBPACK FOOTER //
// ./src/app/views/administration/users/changeUsersRoleForm.component.html